import React from 'react';

import Header from '../Header';
import { DesktopContainer, MainContainer, PageContainer } from './styles';

interface LayoutProps {
  userName?: string;
  userPicture?: string;
  menu: JSX.Element;
  onMenuOpen: () => void;
  onSignOut: () => void;
}

const Layout: React.FC<LayoutProps> = ({
  menu,
  children,
  userPicture,
  userName = '',
  onMenuOpen,
  onSignOut
}) => {
  return (
    <PageContainer>
      {menu}
      <DesktopContainer>
        <Header
          onMenuOpen={onMenuOpen}
          onSignOut={onSignOut}
          userPicture={userPicture}
          userName={userName}
        >
          <MainContainer>{children}</MainContainer>
        </Header>
      </DesktopContainer>
    </PageContainer>
  );
};

export default Layout;
